import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
export var Metric;
(function (Metric) {
    Metric["price"] = "price";
    Metric["weight"] = "weight";
    Metric["volume"] = "volume";
    Metric["density"] = "density";
    Metric["weightPerAnimal"] = "weightPerAnimal";
    Metric["pricePerAnimal"] = "pricePerAnimal";
    Metric["pricePer100Weight"] = "pricePer100Weight";
    Metric["weight100"] = "weight100";
})(Metric || (Metric = {}));
export const MetricsInternational = {
    price: 'metrics:euro',
    weight: 'metrics:kg',
    volume: 'metrics:m³',
    density: 'metrics:kg/m³',
    weightPerAnimal: 'metrics:kg/animal',
    pricePerAnimal: 'metrics:euro/animal',
    pricePer100Weight: 'metrics:euro/100kg',
    weight100: 'metrics:kg100',
};
export const MetricsUk = {
    price: 'metrics:pound',
    weight: 'metrics:kg',
    volume: 'metrics:m³',
    density: 'metrics:kg/m³',
    weightPerAnimal: 'metrics:kg/animal',
    pricePerAnimal: 'metrics:pound/animal',
    pricePer100Weight: 'metrics:pound/100kg',
    weight100: 'metrics:kg100',
};
export const MetricsUs = {
    price: 'metrics:dollar',
    weight: 'metrics:lbs',
    volume: 'metrics:ft³',
    density: 'metrics:lbs/ft³',
    weightPerAnimal: 'metrics:lbs/animal',
    pricePerAnimal: 'metrics:dollar/animal',
    pricePer100Weight: 'metrics:dollar/100lbs',
    weight100: 'metrics:lbs100',
};
export const metricMap = {
    international: MetricsInternational,
    uk: MetricsUk,
    us: MetricsUs,
};
const getRegionalSettingsSystem = (state) => state.profiling
    ? state.profiling.userProfile.settings.regionalSettingsName
    : state.userProfile.settings.regionalSettingsName;
export const getMetric = createSelector([getRegionalSettingsSystem], (regionalSetting) => (metricRequested) => metricMap[regionalSetting][metricRequested]);
export const useWeightUnit = () => {
    const { t } = useTranslation();
    return t(useSelector(getMetric)(Metric.weight)).toLowerCase();
};
//# sourceMappingURL=useGetMetric.js.map